import { render, staticRenderFns } from "./FormPhysicalHeight.vue?vue&type=template&id=83b08c86&"
import script from "./FormPhysicalHeight.vue?vue&type=script&lang=js&"
export * from "./FormPhysicalHeight.vue?vue&type=script&lang=js&"
import style0 from "./FormPhysicalHeight.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports